import Decider from "./Decider";

export default Decider;
